import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from "@/ds/shadcn/components/ui/empty";
import { cn } from "@/ds/utils";
import type { LucideIcon } from "lucide-react";
import { createElement, type FC, type PropsWithChildren } from "react";

export interface StatePanelProps extends PropsWithChildren {
	icon: LucideIcon;
	title: string;
	description?: React.ReactNode;
	compact?: boolean;
	className?: string;
}

export const StatePanel: FC<StatePanelProps> = props => {
	const {
		icon,
		title,
		description,
		compact = false,
		className,
		children
	} = props;

	return (
		<Empty className={cn(compact && "gap-3 p-6 @md:p-6", className)}>
			<EmptyHeader>
				<EmptyMedia variant="icon">
					{createElement(icon)}
				</EmptyMedia>
				<EmptyTitle>{title}</EmptyTitle>
				{
					description &&
					<EmptyDescription>{description}</EmptyDescription>
				}
			</EmptyHeader>
			{
				children &&
				<EmptyContent className="flex-row flex-wrap justify-center gap-3">
					{children}
				</EmptyContent>
			}
		</Empty>
	);
};
